
export enum LicenceBundlePricing {
    SINGLE = 495,
    BUNDLE = 1995,
    BULK = 3995,
}